import React from "react";
import { get, useFormContext } from "react-hook-form";
import { Switch, Alert } from "@material-tailwind/react";

export default function RHFSwitch({ name, ...props }) {
    const { setValue, watch, formState: { errors } } = useFormContext();
    const error = get(errors, name);
    const checked = Boolean(watch(name));

    return (
        <>
            <Switch
                checked={checked}
                onChange={(e) => setValue(name, e.target.checked, {shouldDirty: true, shouldValidate: true})}
                name={name}
                {...props}
            />
            {!!error && (
                <Alert color="red" className="mt-1 rounded-lg py-1 pl-5">
                    {error.message}
                </Alert>
            )}
        </>
    );
}